export default __webpack_public_path__ + "static/logo-18c64b13db3452d9fccae2792a708607.svg";